const initialStates = {
  appState: {
    subscriptionId: null,
    language: 'ar',
    failedTransactionModal: false,
    failedTransactionModalMessage: '',
    cvvModalFlag: false,
    expiryDateModalFlag: false,
    token: null,
    appVersion: null,
  },
  metadata: {
    object: null,
    isLoading: false,
  },
  checkout: {
    isLoading: false,
  },
};

export default initialStates;
